(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const rect = event.target.getBoundingClientRect();
      const header = document.querySelector('.header-wrapper') || document.querySelector('sticky-header') || document.querySelector('.header');
      const headerBottom = header ? Math.round(header.getBoundingClientRect().bottom) : 60;
      const bottom = rect.bottom > 0 ? Math.round(rect.bottom) : headerBottom;
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  // BK Fashion Navigation Controller (Desktop Continuous Hover Debounce & Mobile Single-Open Accordion)
  function initBkNavigation() {
    const headerWrapper = document.querySelector('.header-wrapper') || document.querySelector('sticky-header');
    if (headerWrapper && headerWrapper.dataset.bkNavInitialized === 'true') return;
    if (headerWrapper) headerWrapper.dataset.bkNavInitialized = 'true';

    // 1. Desktop Dropdowns
    const desktopDropdownItems = document.querySelectorAll('.bk-desktop-nav [data-nav-dropdown]');
    desktopDropdownItems.forEach((item) => {
      const link = item.querySelector('.bk-nav__link');
      let closeTimeout = null;

      const openDropdown = () => {
        if (closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }
        desktopDropdownItems.forEach((other) => {
          if (other !== item) {
            other.classList.remove('is-open');
            const otherLink = other.querySelector('.bk-nav__link');
            if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.add('is-open');
        if (link) link.setAttribute('aria-expanded', 'true');
      };

      const closeDropdown = () => {
        closeTimeout = setTimeout(() => {
          item.classList.remove('is-open');
          if (link) link.setAttribute('aria-expanded', 'false');
          item.querySelectorAll('.bk-nav__dropdown-item.is-open').forEach((sub) => {
            sub.classList.remove('is-open');
            const subLink = sub.querySelector('.bk-nav__dropdown-link');
            if (subLink) subLink.setAttribute('aria-expanded', 'false');
          });
        }, 180);
      };

      item.addEventListener('mouseenter', openDropdown);
      item.addEventListener('mouseleave', closeDropdown);

      item.addEventListener('focusin', openDropdown);
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) {
          item.classList.remove('is-open');
          if (link) link.setAttribute('aria-expanded', 'false');
          item.querySelectorAll('.bk-nav__dropdown-item.is-open').forEach((sub) => {
            sub.classList.remove('is-open');
            const subLink = sub.querySelector('.bk-nav__dropdown-link');
            if (subLink) subLink.setAttribute('aria-expanded', 'false');
          });
        }
      });

      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          item.classList.remove('is-open');
          if (link) {
            link.setAttribute('aria-expanded', 'false');
            link.focus();
          }
        }
      });
    });

    // 1b. Desktop Nested Submenus (e.g. CO-ORDS -> DENIM CO-ORDS)
    const desktopSubdropdownItems = document.querySelectorAll('.bk-desktop-nav [data-nav-subdropdown]');
    desktopSubdropdownItems.forEach((subItem) => {
      const subLink = subItem.querySelector('.bk-nav__dropdown-link');
      let subCloseTimeout = null;

      const openSubmenu = () => {
        if (subCloseTimeout) {
          clearTimeout(subCloseTimeout);
          subCloseTimeout = null;
        }
        desktopSubdropdownItems.forEach((other) => {
          if (other !== subItem && other.parentElement === subItem.parentElement) {
            other.classList.remove('is-open');
            const otherLink = other.querySelector('.bk-nav__dropdown-link');
            if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
          }
        });
        subItem.classList.add('is-open');
        if (subLink) subLink.setAttribute('aria-expanded', 'true');
      };

      const closeSubmenu = () => {
        subCloseTimeout = setTimeout(() => {
          subItem.classList.remove('is-open');
          if (subLink) subLink.setAttribute('aria-expanded', 'false');
        }, 180);
      };

      subItem.addEventListener('mouseenter', openSubmenu);
      subItem.addEventListener('mouseleave', closeSubmenu);

      subItem.addEventListener('focusin', openSubmenu);
      subItem.addEventListener('focusout', (e) => {
        if (!subItem.contains(e.relatedTarget)) {
          subItem.classList.remove('is-open');
          if (subLink) subLink.setAttribute('aria-expanded', 'false');
        }
      });

      subItem.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          subItem.classList.remove('is-open');
          if (subLink) {
            subLink.setAttribute('aria-expanded', 'false');
            subLink.focus();
          }
        }
      });
    });

    // 2. Mobile Drawer Close & Backdrop Handlers
    const drawerContainer = document.getElementById('Details-menu-drawer-container');
    const headerDrawerElem = document.querySelector('header-drawer');
    const drawerCloseTriggers = document.querySelectorAll('[data-drawer-close]');
    let drawerCloseTimeout = null;

    const closeMobileDrawer = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (headerDrawerElem && typeof headerDrawerElem.closeMenuDrawer === 'function') {
        const summary = drawerContainer ? drawerContainer.querySelector('summary') : null;
        headerDrawerElem.closeMenuDrawer(e, summary);
      } else if (drawerContainer) {
        drawerContainer.classList.remove('menu-opening');
        const summary = drawerContainer.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
        if (drawerCloseTimeout) clearTimeout(drawerCloseTimeout);
        drawerCloseTimeout = setTimeout(() => {
          drawerContainer.removeAttribute('open');
          drawerCloseTimeout = null;
        }, 300);
        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop', 'overflow-hidden-mobile');
      }
    };

    drawerCloseTriggers.forEach((btn) => {
      btn.onclick = closeMobileDrawer;
    });

    // Immediate first-tap response guard on mobile drawer summary
    const drawerSummary = drawerContainer ? drawerContainer.querySelector('summary') : null;
    if (drawerSummary && drawerContainer) {
      drawerSummary.addEventListener(
        'click',
        function () {
          if (drawerContainer.hasAttribute('open') && !drawerContainer.classList.contains('menu-opening')) {
            if (drawerCloseTimeout) {
              clearTimeout(drawerCloseTimeout);
              drawerCloseTimeout = null;
            }
            drawerContainer.removeAttribute('open');
          }
        },
        true
      );
    }

    // 3. Mobile Drawer Single-Open Accordions (Dynamic Content-Based Height)
    const accordionTriggers = document.querySelectorAll('.bk-mobile-nav [data-accordion-trigger]');

    function closeMobileAccordion(trigger, content) {
      if (!trigger || !content) return;
      trigger.setAttribute('aria-expanded', 'false');

      // Recursively close nested subaccordions inside this content
      const nestedTriggers = content.querySelectorAll('[data-subaccordion-trigger]');
      nestedTriggers.forEach((subTrig) => {
        subTrig.setAttribute('aria-expanded', 'false');
        const subId = subTrig.getAttribute('aria-controls');
        const subContent = subId ? document.getElementById(subId) : subTrig.nextElementSibling;
        if (subContent) {
          subContent.style.maxHeight = '0px';
          subContent.classList.remove('is-open');
        }
      });

      // Collapse smoothly from current height to 0
      content.style.maxHeight = content.scrollHeight + 'px';
      void content.offsetHeight; // Force browser reflow
      content.style.maxHeight = '0px';
      content.classList.remove('is-open');
    }

    function openMobileAccordion(trigger, content) {
      if (!trigger || !content) return;
      trigger.setAttribute('aria-expanded', 'true');
      content.classList.add('is-open');

      const naturalHeight = content.scrollHeight;
      content.style.maxHeight = naturalHeight + 'px';

      const handleEnd = (e) => {
        if (e.target === content && e.propertyName === 'max-height') {
          content.removeEventListener('transitionend', handleEnd);
          if (content.classList.contains('is-open')) {
            content.style.maxHeight = 'none';
          }
        }
      };
      content.addEventListener('transitionend', handleEnd);
      setTimeout(() => {
        if (content.classList.contains('is-open') && content.style.maxHeight !== 'none') {
          content.style.maxHeight = 'none';
        }
      }, 300);
    }

    accordionTriggers.forEach((trigger) => {
      trigger.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isCurrentlyOpen = this.getAttribute('aria-expanded') === 'true';
        const targetId = this.getAttribute('aria-controls');
        const targetContent = targetId ? document.getElementById(targetId) : this.nextElementSibling;

        // Close all other top-level accordions (Single-Open behavior)
        accordionTriggers.forEach((otherTrigger) => {
          if (otherTrigger !== trigger) {
            const otherId = otherTrigger.getAttribute('aria-controls');
            const otherContent = otherId ? document.getElementById(otherId) : otherTrigger.nextElementSibling;
            closeMobileAccordion(otherTrigger, otherContent);
          }
        });

        // Toggle clicked accordion
        if (isCurrentlyOpen) {
          closeMobileAccordion(this, targetContent);
        } else {
          openMobileAccordion(this, targetContent);
        }
      };
    });

    // 4. Mobile Nested Sub-accordions (e.g. CO-ORDS -> DENIM CO-ORDS)
    const subaccordionTriggers = document.querySelectorAll('.bk-mobile-nav [data-subaccordion-trigger]');

    function closeMobileSubAccordion(subTrigger, subContent) {
      if (!subTrigger || !subContent) return;
      subTrigger.setAttribute('aria-expanded', 'false');
      subContent.style.maxHeight = subContent.scrollHeight + 'px';
      void subContent.offsetHeight;
      subContent.style.maxHeight = '0px';
      subContent.classList.remove('is-open');
    }

    function openMobileSubAccordion(subTrigger, subContent) {
      if (!subTrigger || !subContent) return;
      subTrigger.setAttribute('aria-expanded', 'true');
      subContent.classList.add('is-open');
      const naturalHeight = subContent.scrollHeight;
      subContent.style.maxHeight = naturalHeight + 'px';

      const handleSubEnd = (e) => {
        if (e.target === subContent && e.propertyName === 'max-height') {
          subContent.removeEventListener('transitionend', handleSubEnd);
          if (subContent.classList.contains('is-open')) {
            subContent.style.maxHeight = 'none';
          }
        }
      };
      subContent.addEventListener('transitionend', handleSubEnd);
      setTimeout(() => {
        if (subContent.classList.contains('is-open') && subContent.style.maxHeight !== 'none') {
          subContent.style.maxHeight = 'none';
        }
      }, 300);
    }

    subaccordionTriggers.forEach((subTrigger) => {
      subTrigger.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isCurrentlyOpen = this.getAttribute('aria-expanded') === 'true';
        const targetId = this.getAttribute('aria-controls');
        const targetContent = targetId ? document.getElementById(targetId) : this.nextElementSibling;

        if (isCurrentlyOpen) {
          closeMobileSubAccordion(this, targetContent);
        } else {
          openMobileSubAccordion(this, targetContent);
        }
      };
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBkNavigation);
  } else {
    initBkNavigation();
  }

  document.addEventListener('shopify:section:load', initBkNavigation);

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
